<template lang="html">
  <v-app>
    <section class="product">
      <h1 class="black--text" style="margin: 2em auto;">
        タイトル：
        <br />「東方蒼神縁起V」&「東方幻想魔録W」<br />ダブルパック
      </h1>
      <div style="text-align: center; font-size: 1.5em; line-height: 2.5em;">
        <p>ハード：Nintendo Switch</p>
        <p>ジャンル：RPG</p>
        <p>発売日：2023年7月27日</p>
        <p>
          価格：通常版6,578円（税抜5,980円）
          <br />限定版：14,278円（税抜12,980円）
        </p>
        <p>開発：ハチクマソフト</p>
      </div>
    </section>
    <SpecialPackage />
    <ShopSpecial />
  </v-app>
</template>
<style></style>

<script>
  import ShopSpecial from "./ShopSpecial.vue";
  import SpecialPackage from "./SpecialPackage.vue";
  export default {
    name: "App",
    components: {
      ShopSpecial,
      SpecialPackage,
    },
  };
</script>
